/**
 * EventHelper
 * Helps to listen and dispose any type of DOM event:  Usage e.g.
 * @example
 * var eventCancel = EventHelper.on('#cancel','click',function(e){  //event here });
 *  eventCancel.dispose(); // dispose listener
 * @mixin
 */
var EventHelper = {
    query:'',
    /**
     * 
     * @param string query #id .class 
     * @param string event 
     * @param function callback 
     */
    "on": function(query,event,callback){
        if(!query || query === ''){
            throw('EventHelper Provide an element id');
        }
        this.query = query;
        this.event = event;
        this.callback = callback;
        this.element = document.querySelector(this.query);
        if(this.element !==null){
            this.element.addEventListener(this.event,this.callback,false);
        }else {
            throw('the element Id returns a null')
        }
        return this;
    },
    "dispose": function(){
        if(this.element !==null){
            this.element.removeEventListener(this.event,this.callback,false)
        }
    }
};
if (typeof exports !== 'undefined') {
    module.exports = EventHelper;
}